import { AuthContextProps } from "../components/auth-context";
import { getData } from "./core";

export default class ProductTypeApi {
  static uri = "a/internet/productType";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }
  get(id: number, fileId: number | null) {
    if (id === 10) {
      return getData({
        uri: "a/internet/NgnLineSpecs",
        id,
        params: `?lineId=${fileId}`,
        context: this.context,
      });
    } else {
      return getData({
        uri: ProductTypeApi.uri,
        id,
        params: `?lineId=${fileId}`,
        context: this.context,
      });
    }
  }
}
